import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { NewsDetailInitStepDeclaration } from "./Steps/NewsDetailInitStep";

export const NewsDetailStartupFlow = new FlowDefinition("NewsDetailFlow");

NewsDetailStartupFlow.addStep(NewsDetailInitStepDeclaration);

NewsDetailStartupFlow.setStartStep("NewsDetailInit_Step");

export const NewsDetailStartupStepDefinition = new StepDefinition({
    stepName: "NewsDetailFlow",
    stepFlow: NewsDetailStartupFlow,
    contextIsolation: false
})